import type { Dictionary } from '@witmetrics/utils';
import type { OrthoFormParams } from '@witmetrics/unison-core';
import type { ServiceParameterValue } from '@/components/ServiceParameter/types';

// eslint-disable-next-line witmetrics/no-multiline-comments
/* When user switches Infill to "hollow", auto-enable drainage holes
  on that same change. It's a nudge, not a lock — they can still toggle
  drainage off after, and editing other params won't re-force it.
 */
export const applyOrthoSideEffects = (
  params: OrthoFormParams,
  update: Dictionary<ServiceParameterValue>
): OrthoFormParams => {
  const merged = { ...params, ...update };
  if (update.infill === 'hollow') {
    return { ...merged, drainageHoles: 'enabled' };
  }
  return merged;
};
